import gql from "graphql-tag";

export const GET_COPYRIGHT_YEAR = gql`
  query getCopyrightYear {
    getCopyrightYear
  }
`;
